import { render, staticRenderFns } from "./pc-leg-tc-category-block.vue?vue&type=template&id=cfded194&scoped=true&"
import script from "./pc-leg-tc-category-block.vue?vue&type=script&lang=js&"
export * from "./pc-leg-tc-category-block.vue?vue&type=script&lang=js&"
import style0 from "./pc-leg-tc-category-block.vue?vue&type=style&index=0&id=cfded194&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfded194",
  null
  
)

export default component.exports